<div class="tile">
  <div class="header">
    <div class="title">{{ 'DASHBOARD.LAUNCHPAD.TITLE' | translate }}</div>
  </div>
  <div class="body">
    <div class="buttons">
      <div class="button" (click)="gotoLaunchpadClicked()">
        <div class="icon fa">
          <i class="fa fa-undo" aria-hidden="true"></i>
        </div>
        <div class="title">
          <div class="line1">{{ 'DASHBOARD.LAUNCHPAD.LINK.PART_1' | translate }}</div>
          &nbsp;
          <div class="line2">{{ 'DASHBOARD.LAUNCHPAD.LINK.PART_2' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
